'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useEffect, useState } from 'react';
import { useAuth } from '@edusense/shared-auth-core';
import { ComposeModals } from '@edusense/features-tweet-composer';
// 내부 컴포넌트 및 훅 임포트
import SocialPostCompact from './components/SocialPostCompact';
import SocialPostStandard from './components/SocialPostStandard';
import { useSocialPostActions } from './hooks/useSocialPostActions';
import { useSocialPostEvents } from './hooks/useSocialPostEvents';
import { transformApiPollToContentPoll } from '@edusense/entities-communication';
/**
 * 통합 소셜 포스트 컴포넌트
 * 
 * 트윗과 포스트를 하나의 컴포넌트로 통합하여 일관된 UI로 표시합니다.
 */ var SocialPost = function(param) {
    var id = param.id, content = param.content, author = param.author, _param_createdAt = param.createdAt, createdAt = _param_createdAt === void 0 ? new Date() : _param_createdAt, _param_images = param.images, images = _param_images === void 0 ? [] : _param_images, _param_videos = param.videos, videos = _param_videos === void 0 ? [] : _param_videos, _param_likesCount = param.likesCount, likesCount = _param_likesCount === void 0 ? 0 : _param_likesCount, _param_repostsCount = param.repostsCount, repostsCount = _param_repostsCount === void 0 ? 0 : _param_repostsCount, _param_repliesCount = param.repliesCount, repliesCount = _param_repliesCount === void 0 ? 0 : _param_repliesCount, _param_viewsCount = param.viewsCount, viewsCount = _param_viewsCount === void 0 ? 0 : _param_viewsCount, _param_isLiked = param.isLiked, isLiked = _param_isLiked === void 0 ? false : _param_isLiked, _param_isReposted = param.isReposted, isReposted = _param_isReposted === void 0 ? false : _param_isReposted, _param_isQuote = param.isQuote, isQuote = _param_isQuote === void 0 ? false : _param_isQuote, quotedContent = param.quotedContent, linkPreview = param.linkPreview, _param_isRetweet = param.isRetweet, isRetweet = _param_isRetweet === void 0 ? false : _param_isRetweet, originalPost = param.originalPost, retweetAuthor = param.retweetAuthor, replyToUser = param.replyToUser, _param_showThreadLineTop = param.showThreadLineTop, showThreadLineTop = _param_showThreadLineTop === void 0 ? false : _param_showThreadLineTop, _param_showThreadLineBottom = param.showThreadLineBottom, showThreadLineBottom = _param_showThreadLineBottom === void 0 ? false : _param_showThreadLineBottom, _param_displayStyle = param.displayStyle, displayStyle = _param_displayStyle === void 0 ? 'default' : _param_displayStyle, _param_showActions = param.showActions, showActions = _param_showActions === void 0 ? true : _param_showActions, _param_isDetailView = param.isDetailView, isDetailView = _param_isDetailView === void 0 ? false : _param_isDetailView, _param_dataSource = param.dataSource, dataSource = _param_dataSource === void 0 ? 'default' : _param_dataSource, onLike = param.onLike, onRepost = param.onRepost, onQuote = param.onQuote, onComment = param.onComment, onClick = param.onClick, path = param.path, poll = param.poll, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onDeleteSuccess = param.onDeleteSuccess, _param_variant = param.variant, variant = _param_variant === void 0 ? displayStyle : _param_variant, onPollVote = param.onPollVote, _param_disableViewTracking = param.disableViewTracking, disableViewTracking = _param_disableViewTracking === void 0 ? false : _param_disableViewTracking;
    // 편집 모달 상태
    var _useState = _sliced_to_array(useState(false), 2), editModalOpen = _useState[0], setEditModalOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), editingTweet = _useState1[0], setEditingTweet = _useState1[1];
    // 컴포넌트 렌더링 시 onDeleteSuccess prop 값 로깅
    useEffect(function() {
        console.log("[SocialPost ".concat(id, "] onDeleteSuccess prop 값:"), typeof onDeleteSuccess === "undefined" ? "undefined" : _type_of(onDeleteSuccess));
    }, [
        onDeleteSuccess,
        id
    ]);
    // 액션 관련 상태와 핸들러
    var _useSocialPostActions = useSocialPostActions(id, isLiked, isReposted, onLike, onRepost, onQuote, onComment, onDeleteSuccess), likeState = _useSocialPostActions.likeState, repostState = _useSocialPostActions.repostState, handleLike = _useSocialPostActions.handleLike, handleRepost = _useSocialPostActions.handleRepost, handleQuote = _useSocialPostActions.handleQuote, handleComment = _useSocialPostActions.handleComment, handleDeleteTweet = _useSocialPostActions.handleDeleteTweet, handleReportTweet = _useSocialPostActions.handleReportTweet;
    // 이벤트 및 네비게이션 처리
    var _useSocialPostEvents = useSocialPostEvents(id, isDetailView, dataSource, path, onClick, disableViewTracking), postRef = _useSocialPostEvents.postRef, viewTrackerRef = _useSocialPostEvents.viewTrackerRef, clickHandler = _useSocialPostEvents.clickHandler, handleCompactClick = _useSocialPostEvents.handleCompactClick;
    // useAuth에서 user만 가져옴 (isAuthenticated 제거)
    var _useAuth = useAuth(), currentUser = _useAuth.user;
    // 트윗 편집 핸들러
    var handleEditTweet = function() {
        setEditingTweet({
            id: id,
            content: content || '',
            author: author
        });
        setEditModalOpen(true);
    };
    // 편집된 트윗 제출 핸들러
    var handleEditSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(data) {
            return _ts_generator(this, function(_state) {
                try {
                    // TODO: 트윗 편집 API 호출
                    console.log('트윗 편집 요청:', {
                        id: id,
                        content: data.content
                    });
                    // 성공 시 모달 닫기
                    setEditModalOpen(false);
                    setEditingTweet(null);
                    // 필요한 경우 새로고침 콜백 호출
                    if (onDeleteSuccess) {
                        onDeleteSuccess();
                    }
                } catch (error) {
                    console.error('트윗 편집 중 오류:', error);
                }
                return [
                    2
                ];
            });
        });
        return function handleEditSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    // ID가 없으면 렌더링하지 않음
    if (!id) {
        console.warn('[SocialPost] 게시물 ID가 없습니다');
        return null;
    }
    // 원본 게시물 정보 (리트윗인 경우)
    var originalPostExists = isRetweet && originalPost;
    // 투표 핸들러
    var handleVote = function(optionId) {
        if (onPollVote) {
            onPollVote(optionId);
        } else {
            console.warn('onPollVote 핸들러가 정의되지 않았습니다');
        }
    };
    // API 응답의 poll 구조를 ContentBase 형식으로 변환 (투표 핸들러 포함)
    var transformedPoll = poll ? transformApiPollToContentPoll(poll, handleVote) : null;
    // 원본 PollData 타입 데이터 (SocialPostProps 타입 유지)
    var originalPollData = poll;
    // 표시할 게시물 데이터에 transformedPoll과 onVote 핸들러 추가
    var displayPost = {
        id: id,
        content: content || '',
        author: author,
        createdAt: createdAt,
        images: images || [],
        videos: videos || [],
        linkPreview: linkPreview,
        quotedContent: quotedContent,
        poll: transformedPoll
    };
    // 변형에 따라 다른 컴포넌트 렌더링
    if (variant === 'compact' && onClick) {
        return /*#__PURE__*/ React.createElement(SocialPostCompact, {
            id: id,
            content: content,
            author: author,
            createdAt: createdAt,
            images: images,
            videos: videos,
            likesCount: likesCount,
            repostsCount: repostsCount,
            repliesCount: repliesCount,
            viewsCount: viewsCount,
            isLiked: isLiked,
            isReposted: isReposted,
            isQuote: isQuote,
            quotedContent: quotedContent,
            linkPreview: linkPreview,
            isRetweet: isRetweet,
            originalPost: originalPost,
            retweetAuthor: retweetAuthor,
            replyToUser: replyToUser,
            showThreadLineTop: showThreadLineTop,
            showThreadLineBottom: showThreadLineBottom,
            displayStyle: displayStyle,
            showActions: showActions,
            isDetailView: isDetailView,
            dataSource: dataSource,
            onLike: onLike,
            onRepost: onRepost,
            onQuote: onQuote,
            onComment: onComment,
            onClick: onClick,
            path: path,
            poll: poll,
            className: className,
            onDeleteSuccess: onDeleteSuccess,
            viewTrackerRef: viewTrackerRef,
            handleCompactClick: handleCompactClick
        });
    }
    // 기본 모드는 SocialPostStandard 컴포넌트 사용
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SocialPostStandard, {
        id: id,
        content: content,
        author: author,
        createdAt: createdAt,
        images: images,
        videos: videos,
        likesCount: likesCount,
        repostsCount: repostsCount,
        repliesCount: repliesCount,
        viewsCount: viewsCount,
        isLiked: isLiked,
        isReposted: isReposted,
        isQuote: isQuote,
        quotedContent: quotedContent,
        linkPreview: linkPreview,
        isRetweet: isRetweet,
        originalPost: originalPost,
        retweetAuthor: retweetAuthor,
        replyToUser: replyToUser,
        showThreadLineTop: showThreadLineTop,
        showThreadLineBottom: showThreadLineBottom,
        displayStyle: displayStyle,
        showActions: showActions,
        isDetailView: isDetailView,
        dataSource: dataSource,
        onLike: onLike,
        onRepost: onRepost,
        onQuote: onQuote,
        onComment: onComment,
        onClick: onClick,
        path: path,
        poll: originalPollData,
        className: className,
        onDeleteSuccess: onDeleteSuccess,
        displayPost: displayPost,
        likeState: likeState,
        repostState: repostState,
        handleDeleteTweet: handleDeleteTweet,
        handleReportTweet: handleReportTweet,
        handleEditTweet: handleEditTweet,
        handleLike: handleLike,
        handleRepost: handleRepost,
        handleQuote: handleQuote,
        handleComment: handleComment,
        clickHandler: clickHandler,
        postRef: postRef,
        viewTrackerRef: viewTrackerRef
    }), /*#__PURE__*/ React.createElement(ComposeModals, {
        composeModalOpen: editModalOpen,
        setComposeModalOpen: setEditModalOpen,
        quoteModalOpen: false,
        setQuoteModalOpen: function() {},
        replyModalOpen: false,
        setReplyModalOpen: function() {},
        selectedTweet: editingTweet,
        handleTweetSubmit: handleEditSubmit
    }));
};
export default SocialPost;
